// Third-party / external service base URLs (single source of truth)

export const AI_SERVICE_BASE_URL = 'https://vidai-ai.in';
